export const allCardsDefaultColumns = [
  { label: 'Status', value: 'status' },
  { label: 'Núm. do cartão', value: 'card_number' },
  { label: 'Tipo', value: 'type' },
  { label: 'Empresa', value: 'company_branch' },
  { label: 'Filial', value: 'branch_display_name' },
  { label: 'Associado', value: 'owner_or_equipment' },
  { label: 'Solicitado em', value: 'created_at' },
  { label: 'Última atualização', value: 'updated_at' },
  { label: 'Ações', value: 'action', className: 'w-9' },
];
